
<template>
	<div v-if="cookieSettingsOpen">
		<div class="cookiedetails-overlay"></div>
		<div class="cookiedetails-popup">
			<div class="cookiedetails-content">
				<h3 class="cookiedetails-header">Piškotki in nastavitve zasebnosti</h3>
				<hr>
				<div class="interaction">
					<aside class="interaction-links">
						<div :class="`link-item ${activeClass(0) ? 'active' : ''}`" @click="showContent(0)">Kako uporabljamo piškotke</div>
						<div :class="`link-item ${activeClass(1) ? 'active' : ''}`" @click="showContent(1)">Nujni piškotki</div>
						<!-- <div :class="`link-item ${activeClass(2) ? 'active' : ''}`" @click="showContent(2)">Piškotki Matomo Analytics</div> -->
						<div :class="`link-item ${activeClass(3) ? 'active' : ''}`" @click="showContent(3)">Drugi piškotki</div>
						<div :class="`link-item ${activeClass(4) ? 'active' : ''}`" @click="showContent(4)">Izjava o varstvu osebnih podatkov</div>
					</aside>
					<article class="interaction-content">
						<p v-for="(item, index) in cookieContent[contentID]" :key="index">
							<span v-html="item"></span>
						</p>
                        <!-- NUJNI PIŠKOTKI -->
                        <div v-if="contentID == 1" class="track-options freeze">
							<input type="checkbox" name="nujnipiskotki" v-model="cookies.nujni.checked" v-bind:id="cookies.nujni.id">
							<span class="toggle-track" @click="void 0"></span>
							<div class="track-text d-inline">
                                <span :class="cookies.nujni.checked ? 'enabled' : ''">DA</span>
                                /
                                <span :class="!cookies.nujni.checked ? 'enabled' : ''">NE</span>
                            </div>
                            <span class="nujni-text"> &nbsp;&nbsp; Nujni piškotki – potrebni za zagotovitev storitev, ki so na voljo na naši spletni strani, in za uporabo nekaterih njenih funkcij.</span>
							<br>
						</div>
                        <!-- POPUP PIŠKOTKI -->
                        <div v-if="contentID == 3" class="track-options">
							<input type="checkbox" name="popup-consent" v-model="cookies.popups.checked" v-bind:id="cookies.popups.id">
							<span class="toggle-track" @click="togglePopups"></span>
							<div class="track-text d-inline">
                                <span :class="cookies.popups.checked ? 'enabled' : ''">DA</span>
                                /
                                <span :class="!cookies.popups.checked ? 'enabled' : ''">NE</span>
                            </div>
                            <span class="popups-text"> &nbsp;&nbsp; Beleženje prikaza oglasov (pop-up)</span>

							<p></p>
                            <input type="checkbox" name="analytics-consent" v-model="cookies.analytics.checked" v-bind:id="cookies.analytics.id">
							<span class="toggle-track" @click="toggleAnalyticsDecision"></span>
							<div class="track-text d-inline">
                                <span :class="cookies.analytics.checked ? 'enabled' : ''">DA</span>
                                /
                                <span :class="!cookies.analytics.checked ? 'enabled' : ''">NE</span>
                            </div>
                            <span class="analytics-text"> &nbsp;&nbsp; Beleženje analitike (Matomo)</span>

							<p></p>
                            <p class="track-text">Kliknite, če želite omogočiti / onemogočiti.</p>
						</div>
                        <!-- ANALITIČNI PIŠKOTKI -->
						<!-- <div v-if="contentID == 2" class="track-options">
							<input type="checkbox" name="analyticCookieCheck" v-model="cookies.analytics.checked" v-bind:id="cookies.analytics.id">
							<span class="toggle-track" @click="toggleAnalyticsDecision"></span>
							<p class="track-text">Kliknite, če želite <span :class="cookies.analytics.checked ? 'enabled' : ''"> omogočiti </span> / <span :class="cookies.analytics.checked ? '' : 'enabled'"> onemogočiti </span> sledenje Google Analytics. </p>
							<br>
							<p class="track-text">Omogočite to funkcijo v nastavitvah brskalnika in ponovno naložite stran.</p>
						</div> -->
					</article>
				</div>
				<div class="btn-container">
					<button v-on:click="sprejmiNastavitve()">Sprejmi nastavitve</button>
					<button v-on:click="hideCookieToolbar()">{{ piskotki == null ? "Skrij le vrstico s sporočilom" : "Zapri nastavitve"}}</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import cookieContent from "../cookieContent";

	export default {
        props: ['cookieSettingsOpen', 'hideCookieToolbar','piskotki'],
		data() {
			return {
				show: false,
				contentID: 0,
				cookieContent: cookieContent,
				cookies: {
					all: {
						id: "all",
						checked: true
					},
					analytics: {
						id: "analyticCookieCheck",
                        checked: this.getAnalyticsCookieConsent(),
						cookies: ['matomo', '_pk_']

					},
                    external: {
                        id: "externalCookieCheck",
                        checked: false,
                        cookies: []
                    },
                    nujni: {
                        id: "nujnipiskotki",
                        checked: true,
                        freeze: true,
                        cookies: ['site-cookie-consent', 'site-popup-consent', 'analitycs-consent', 'XSRF-TOKEN', 'izzirokus_session']
                    },
                    popups: {
                        id: "popup-consent",
                        checked: this.getPopupCookieConsent(),
						cookies: ['popup']
                    }
				}
			}
		},
		mounted() {
			this.removeObsoleteSubdomainCookies();
		},
		methods: {
			removeObsoleteSubdomainCookies() {
				const allCookies = this.$cookies.keys();
				const subdomainCookies = allCookies.filter(cookie => cookie.indexOf("_pk_") !== -1);
				subdomainCookies.forEach(cookie => this.$cookies.remove(cookie, "/", "." + window.location.hostname));
			},
            getAnalyticsCookieConsent() {
                if (this.$cookies.get("analytics-consent") === "true") {
                    return true;
                } else {
                    return false;
                }
            },
            getPopupCookieConsent() {
                if (this.$cookies.get("site-popup-consent") === "true") {
                    return true;
                } else {
                    return false;
                }
            },
			showContent(contentId) {
				this.contentID = contentId;
			},
			toggleAnalyticsDecision() {
				this.cookies.analytics["checked"] = !this.cookies.analytics["checked"];
                if (!this.cookies.analytics["checked"]) {
                    this.removeUnnecessaryCookies({cookiesNotToRemove: "popups"});
                }
			},
            togglePopups() {
				this.cookies.popups["checked"] = !this.cookies.popups["checked"];
                if (!this.cookies.popups["checked"]) {
                    this.removeUnnecessaryCookies({cookiesNotToRemove: "analytics"});
                }
			},
            removeUnnecessaryCookies({ cookiesNotToRemove }) {
                const allCookies = this.$cookies.keys();

                const necessaryCookies = allCookies.filter(cookieAll =>
                    this.cookies.nujni.cookies.some(necessaryCookie => necessaryCookie.indexOf(cookieAll) !== -1 || cookieAll.indexOf(necessaryCookie) !== -1)
                );
                const noDeletionCookies = allCookies.filter(noDeletionCookie =>
                    this.cookies[cookiesNotToRemove].cookies.some(necessaryCookie => necessaryCookie.indexOf(noDeletionCookie) !== -1 || noDeletionCookie.indexOf(necessaryCookie) !== -1)
                );
                const cookiesToDelete = allCookies
                    .filter(necessary_cookie => !necessaryCookies.includes(necessary_cookie))
                    .filter(no_deletion_cookie => !noDeletionCookies.includes(no_deletion_cookie));

                cookiesToDelete.forEach(cookie => this.$cookies.remove(cookie));

            },
			sprejmiNastavitve() {
				this.$cookies.set('site-cookie-consent', true, 60 * 60 * 24 * 365);
				this.$cookies.set('analytics-consent', this.cookies.analytics["checked"], 60 * 60 * 24 * 365);
				this.$cookies.set('site-popup-consent', this.cookies.popups["checked"], 60 * 60 * 24 * 365);
				this.hideCookieToolbar();

			},
			activeClass(contentId) {
				return this.contentID == contentId;
			}
		}
	}
</script>
